import { ConcreteEncodable } from "./ConcreteEncodable";

import { FixingDataImplEncoder } from "../../encoder/FixingDataImplEncoder";

import * as CubiqTS from "../../index";
import { FixingData } from "../FixingData";

export class FixingDataImpl extends ConcreteEncodable implements FixingData {
  public static enType: string = "com.bcdfx.model.event.lifecycle.fx.FixingDataImpl";

  /*FID=100*/
  public messageId: string;
  /*FID=910*/
  public bmOrderType: CubiqTS.BenchmarkOrderType;
  /*FID=911*/
  public revalStatus: CubiqTS.RevaluationStatus;
  /*FID=912*/
  public stpTarget: boolean;
  /*FID=913*/
  public traderVisibilityOffset: CubiqTS.Long | null = null;
  /*FID=914*/
  public reqFixingDate: string;
  /*FID=915*/
  public reqFixingTime: string;
  /*FID=916*/
  public reqFixingTzCd: string;
  /*FID=917*/
  public reqFixingCd: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = FixingDataImplEncoder.Instance;
    this.setEncodableType(FixingDataImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "FixingDataImpl[" +
      "messageId=" +
      this.messageId +
      "bmOrderType=" +
      this.bmOrderType +
      "revalStatus=" +
      this.revalStatus +
      "stpTarget=" +
      this.stpTarget +
      "traderVisibilityOffset=" +
      this.traderVisibilityOffset +
      "reqFixingDate=" +
      this.reqFixingDate +
      "reqFixingTime=" +
      this.reqFixingTime +
      "reqFixingTzCd=" +
      this.reqFixingTzCd +
      "reqFixingCd=" +
      this.reqFixingCd +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
